import React from "react";
import styled from "styled-components";
import Input from "components/Input";
import TextArea from "components/TextArea";
import { SCREENING_TYPE_OPTIONS } from "constants/index";

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #525252;
`;

const NativeSelect = styled.select`
  height: 40px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 14px;
  color: #333;
  background: #fff;
  width: 100%;

  &:focus {
    outline: none;
    border-color: #4e86ff;
  }
`;

const ToggleRow = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  cursor: pointer;
`;

function FormMetaStep({ formValues, setFormValues }) {
  return (
    <>
      <Grid>
        <InputGroup>
          <Label>Nome</Label>
          <Input
            value={formValues.name}
            onChange={(e) => setFormValues({ ...formValues, name: e.target.value })}
            placeholder="Nome do formulário"
          />
        </InputGroup>
        <InputGroup>
          <Label>Versão</Label>
          <Input
            value={formValues.version}
            onChange={(e) => setFormValues({ ...formValues, version: e.target.value })}
            placeholder="1.0"
          />
        </InputGroup>
        <InputGroup>
          <Label>Tipo de triagem</Label>
          <NativeSelect
            value={formValues.screeningType}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                screeningType: e.target.value === "" ? "" : Number(e.target.value),
              })
            }
          >
            <option value="">Nenhum</option>
            {SCREENING_TYPE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </NativeSelect>
        </InputGroup>
      </Grid>

      <InputGroup style={{ marginTop: 16 }}>
        <Label>Descrição</Label>
        <TextArea
          value={formValues.description}
          onChange={(e) => setFormValues({ ...formValues, description: e.target.value })}
          placeholder="Descrição do formulário"
        />
      </InputGroup>

      <ToggleRow>
        <input
          type="checkbox"
          checked={formValues.isCurrent}
          onChange={(e) =>
            setFormValues({ ...formValues, isCurrent: e.target.checked })
          }
        />
        Marcar como formulário ativo
      </ToggleRow>
    </>
  );
}

export default FormMetaStep;
